import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { BroadcastsList } from "./broadcasts-list";
import { CapturesTab } from "./captures-tab";

/**
 * Workspace-level Broadcasts surface (dashboard Settings → Broadcasts) — two tabs:
 *  - Broadcasts: the home of every broadcast. Set ONE schedule, pick N published projects,
 *    choose how they're delivered; one engine broadcast holds all of it. Also where a
 *    multi-project broadcast is edited (the per-project tab shows it read-only).
 *  - Snapshots: the searchable, paged archive of every stored capture across the workspace
 *    (the engine calls them captures; the UI says Snapshots, like OptiSigns).
 */
export function WorkspaceBroadcastsPage(): JSX.Element {
  return (
    <Tabs defaultValue="broadcasts" className="mx-auto w-full max-w-5xl">
      <TabsList className="mb-4">
        <TabsTrigger value="broadcasts" data-testid="broadcast-tab-broadcasts">
          Broadcasts
        </TabsTrigger>
        <TabsTrigger value="captures" data-testid="broadcast-tab-captures">
          Snapshots
        </TabsTrigger>
      </TabsList>
      <TabsContent value="broadcasts">
        <BroadcastsList scope={{ kind: "workspace" }} />
      </TabsContent>
      <TabsContent value="captures">
        <CapturesTab />
      </TabsContent>
    </Tabs>
  );
}
